﻿//-------------------------------------------------------------------------------------
// Get Operation
//-------------------------------------------------------------------------------------

export interface GetOperationResponse extends Operation {}

//-------------------------------------------------------------------------------------
// Get Operations
//-------------------------------------------------------------------------------------

export interface GetOperationsResponse {
    Operations?: Array<Operation>;
}

//-------------------------------------------------------------------------------------
// Shared
//-------------------------------------------------------------------------------------

export interface Operation {
    Id: string;
    Created: string;
    Status: GatheringStatus;
    Items?: Array<Item>;
    SubjectIdentifier?: string;
    SubjectIdentifierType?: string;
    ContextIdentifier?: string;
    ContextIdentifierType?: string;
}

export interface Item {
    Id: string;
    Type?: string;
    TypeParameters?: string;
    TypeParametersVersion?: string;
    Source?: string;
    Status: GatheringStatus;
    Updated: string;
    DeviceIdentifier?: string;
}

export enum GatheringStatus {
    Pending = "Pending",
    InProgress = "InProgress",
    Collected = "Collected",
    Skipped = "Skipped",
    Success = "Success",
    Warning = "Warning",
    Error = "Error",
}
